import React from "react";

import { IMedicalFormItemConfigProps, IMedicalFormItemProps } from "../../Types/IMedicalFormItemProps";
import BaseComposableFormItem from "./BaseComposableFormItem";

const nullElement = () => null;

/**
 * An implementation of {@link BaseComposableFormItem} that does not render any form element, and should be used for
 * dialogue only.
 */
const NoElementFormItem: React.FC<IMedicalFormItemConfigProps & IMedicalFormItemProps> = props => (
  <BaseComposableFormItem {...props} FormElement={nullElement} />
);

export default NoElementFormItem;
